import { TWIRE_ASSETS_URL } from "../constants";

export class Assets {
  static getDRKN = (image: string): string => {
    return `${TWIRE_ASSETS_URL}drkn/${image}`;
  };
}
